
import productCacheService from '../components/IndexDB/productCacheService';
import customerCacheService from '../components/IndexDB/customerCacheService';
import moment from 'moment';

let intervalId = null;

export default {
  start(interval = 10 * 60 * 1000) {
    console.log(
      `[CacheRefreshService] 🔁 Starting auto-refresh every ${interval / 60000} min(s)`
    );

    // Run immediately
    this.refresh();

    // Set interval
    intervalId = setInterval(() => {
      this.refresh();
    }, interval);
  },

  async refresh() {
    const time = moment().format('HH:mm:ss DD/MM/YYYY');
    console.log(`\n[CacheRefreshService] 🔄 Refresh triggered at ${time}`);

    try {
      console.log('[CacheRefreshService] 🛒 Updating products...');
      const products = await productCacheService.getProducts();
      console.log(
        `[CacheRefreshService] ✅ Products updated (${products.length} items)`
      );
    } catch (e) {
      console.warn('[CacheRefreshService] ⚠️ Failed to update products:', e.message);
    }

    try {
      console.log('[CacheRefreshService] 👥 Updating customers...');
      const customers = await customerCacheService.getCustomers();
      console.log(
        `[CacheRefreshService] ✅ Customers updated (${customers.length} entries)`
      );
    } catch (e) {
      console.warn('[CacheRefreshService] ⚠️ Failed to update customers:', e.message);
    }
  },

  stop() {
    if (intervalId) {
      clearInterval(intervalId);
      console.log('[CacheRefreshService] ⏹️ Auto-refresh stopped.');
    }
  }
};
